// TODO: TRANSLATION PATTERN
// TODO: REFACTORING
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {
  parseISO,
  format,
  differenceInYears,
  differenceInMonths,
} from 'date-fns';
import * as Styled from './CertificationModal.style';
import { sprintf } from 'sprintf-js';
import { translate as t } from '@utils/translate';

const CertificationModal = ({ certifications, closeModal }) => {
  const [modal, setModal] = useState(null);
  const TEXTS = {
    SEE_DETAILS: t('seeDetails'),
    ONE_YEAR_EXPIRATION: t('expiresInOneYear'),
    EXPIRATION_YEARS: t('expirationYears'),
    EXPIRATION_MONTHS: t('expirationMonths'),
    FIRST_CERTIFICATION: t('firstCertification'),
  };

  const firstCertificated = certification =>
    certification.firstCertificatedAt
      ? format(parseISO(certification.firstCertificatedAt), 'yyyy')
      : '';

  const renderExpirationTime = certification => {
    let expirationTime = differenceInYears(
      parseISO(certification.expirationDate),
      new Date()
    );

    if (expirationTime === 1) return TEXTS.ONE_YEAR_EXPIRATION;
    if (expirationTime > 1)
      return sprintf(TEXTS.EXPIRATION_TIME, expirationTime);

    expirationTime = differenceInMonths(
      parseISO(certification.expirationDate),
      new Date()
    );

    if (expirationTime > 1)
      return sprintf(TEXTS.EXPIRATION_MONTHS, expirationTime);

    return null;
  };

  useEffect(() => {
    setModal(document.querySelector('#___gatsby'));
  }, []);

  if (!modal) return null;

  return ReactDOM.createPortal(
    <Styled.ModalContainer>
      <Styled.Modal>
        <Styled.ModalTitle>
          <Styled.ModalClose onClick={closeModal}>
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 512 512"
            >
              {' '}
              <polygon points="512,236.011 76.526,236.011 248.43,64.106 220.162,35.838 0,256 220.162,476.162 248.43,447.894 76.526,275.989 512,275.989" />
            </svg>
          </Styled.ModalClose>
          {t('airCarrierCertificate')}
        </Styled.ModalTitle>
        {certifications.map(certification => {
          return (
            <Styled.ModalContent key={certification.id}>
              <Styled.ImageWrapper>
                <Styled.Image src={certification.certification.iconImageUrl} />
              </Styled.ImageWrapper>
              <Styled.CertificationInformation>
                <Styled.CertificationName>
                  {certification.certification.name}
                  {certification.certification.isLive === 1 ? (
                    <Styled.CertificationStatus>
                      Live
                    </Styled.CertificationStatus>
                  ) : (
                    ''
                  )}
                </Styled.CertificationName>

                <Styled.CertificationExpires>
                  {renderExpirationTime(certification)}
                </Styled.CertificationExpires>

                <Styled.CertificationDate>
                  {TEXTS.FIRST_CERTIFICATION} {firstCertificated(certification)}
                </Styled.CertificationDate>
              </Styled.CertificationInformation>
            </Styled.ModalContent>
          );
        })}
      </Styled.Modal>
    </Styled.ModalContainer>,
    modal
  );
};

export default CertificationModal;
